module.exports = __webpack_public_path__ + "static/CO2mpensio-3488e686decf4cb79dc9e43697db40ee.jpg";